/**
 * Re-measures a scroll container whenever its own box or its content's box
 * changes. `window.resize` alone misses the cases that matter here: the trade
 * page table is drag-resizable, and switching tabs swaps in a table of a
 * different width without the window ever resizing.
 *
 * Returns a cleanup function.
 */
export function observeElementSize(
	container: HTMLElement,
	onResize: () => void
): () => void {
	const observer = new ResizeObserver(onResize);

	observer.observe(container);
	// The container's own box doesn't change when its content gets wider, so the
	// content needs watching too — that's what drives overflow.
	const content = container.firstElementChild;
	if (content) observer.observe(content);

	return () => observer.disconnect();
}
